module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bbf3d3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Modal/Modal.vue
// module id = 724
// module chunks = 0